module.exports = __webpack_public_path__ + "8ef71f59c92b6371bb6c02311a6cc8bf.pdf";